import React from 'react';
import PropTypes from 'prop-types';
import { createTheme, StylesProvider } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { functional, promo500, promo700, form700, error, neutral0 } from '@fever/ui';

const commonOverrides = {
    overrides: {
        MuiTab: {
            root: {
                textTransform: 'capitalize !important',
                '&.MuiTab-root': {
                    textTransform: 'capitalize !important'
                }
            },
            label: {
                textTransform: 'capitalize !important'
            }
        },
        MuiButton: {
            root: {
                textTransform: 'capitalize !important'
            },
            label: {
                textTransform: 'capitalize !important'
            }
        },
        MuiTypography: {
            button: {
                textTransform: 'capitalize !important'
            }
        }
    }
};

export const promoTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            light: promo500,
            main: functional,
            dark: promo700,
            contrastText: neutral0
        },
        secondary: { main: form700 }
    },
    typography: {
        fontFamily: [
            'Noto Sans TC',
            'Noto Sans CJK TC',
            'Roboto',
            'PingFang TC',
            'Helvetica',
            'Arial',
            'sans-serif'
        ].join(',')
    },
    ...commonOverrides
});

export const formTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: functional,
            contrastText: neutral0
        },
        secondary: { main: error, contrastText: neutral0 }
    },
    typography: {
        fontFamily: [
            'Noto Sans TC',
            'Noto Sans CJK TC',
            'Roboto',
            'PingFang TC',
            'Helvetica',
            'Arial',
            'sans-serif'
        ].join(',')
    },
    ...commonOverrides
});

function ThemeProvider({ children, theme }) {
    return (
        <MuiThemeProvider theme={theme}>
            <StylesProvider injectFirst>{children}</StylesProvider>
        </MuiThemeProvider>
    );
}

ThemeProvider.propTypes = {
    children: PropTypes.node,
    theme: PropTypes.object
};

export default ThemeProvider;
